import axios from 'axios'

/**
 * Returns the consumer object
 *
 * @returns {Promise<Object>}
 */
export default function consumersProfile() {
  return axios.get('/api/account-management/consumers/profile')
}
